{
  "referenceLine": "Reference line",
  "parsingTemplates": "Parsing templates",
  "parsingResult": "Parsing result",
  "includeAutoParsedFields": "Include auto-parsed fields",
  "timeRange": "Time range",
  "query": "Query",
  "run": "Run",
  "aggregatedFields": "Aggregated fields",
  "usePercentage": "% instead of count",
  "noResults": {
    "title": "No results found",
    "description": "We could not find any lines matching your search criteria"
  },
  "emptyState": {
    "description": "Create your template above and run it to see parsing results."
  },
  "percent": "Percent",
  "count": "Count"
}